import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { OfferStatus } from '@recruitee/offers-types';

type TrackPublishParams = {
  jobStatus: OfferStatus;
  hasPublish: boolean;
  hasClose: boolean;
};

@Injectable({ providedIn: 'root' })
export class JobSchedulerAnalytics extends AnalyticsBase {
  public readonly namespace = `JobScheduler`;
  public readonly requireViewContext = false;

  public trackSchedulePublish(params: TrackPublishParams): void {
    this.track('SchedulePublish', params);
  }

  public trackFilterScheduled(): void {
    this.track('FilterScheduled');
  }
}
